// extracted by mini-css-extract-plugin
export default {"menuBlock":"qN-z","title":"rN-z","nav":"sN-z","flexCell":"tN-z","facetLink":"uN-z"};